import Stomp from "stompjs";

export default class StompSocket {
  stompClient;
  constructor(serverUrl = "") {
    this.stompClient = Stomp.client(serverUrl, [
      "v10.stomp",
      "v11.stomp",
      "v12.stomp",
    ]);
    this.stompClient.debug = () => {};
  }
  connect(headers, onAcknowledge, onSubscribe, onDisConnect = () => { }) {
    this.stompClient.connect(
      headers,
      () => {
        onAcknowledge();
        onSubscribe();
      },
      () => {
        onDisConnect();
        this.connect(headers, onAcknowledge, onSubscribe);
      }
    )
  }
  send(destination) {
    this.stompClient.send(destination);
  }
  subscribe(destination, onMessage) {
    this.stompClient.subscribe(destination, (frameMessage) => {
      onMessage(frameMessage);
    });
  }
  unSubscribe() {
    this.stompClient.unsubscribe();
  }
  onDisConnect(callback = () => { }) {
    this.stompClient.ws.onclose = () => {
      callback()
    }
  }
}
